import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Icon from '../Icon';
import Category from './Category';
import {
  Content,
  Header,
  HeaderContentWrapper,
  Root,
  VerticalLine
} from './styles';
import color from '../../theme/color';
import IconSVG from '../Icon/IconSVG';
import styled from 'styled-components';
import { media } from '../../styles/media';

class Filter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  handleClick = () => {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  };

  isCategoryChecked = category => {
    const { filters } = this.props;
    return filters && filters.length > 0
      ? Object.values(filters[category]).find(filter => filter) || false
      : null;
  };

  renderItem = ({ id, label, children }, index) => {
    const checked = children
      ? this.isCategoryChecked(id)
      : this.props.filters[id];
    const { filters, toggleCategory } = this.props;
    let props = {
      key: index,
      id,
      label,
      onCategoryChange: toggleCategory,
      checked,
      filters
    };

    if (children) {
      props.items = Object.values(children);
      props.onFilterChange = this.props.toggleFilter;
    }

    return <Category {...props} />;
  };

  renderItems = () => {
    const { data } = this.props;
    return data && data.length > 0 ? data.map(this.renderItem) : false;
  };

  render() {
    const { title } = this.props;

    return (
      <Root open={this.state.open}>
        <Header onClick={this.handleClick}>
          <HeaderContentWrapper>
            <IconSVG
              name={this.state.open ? 'close' : 'filter'}
              color={color.brand.accent}
              mr={10}
            />
            {title}
          </HeaderContentWrapper>
          <VerticalLine />
        </Header>
        <Content>{this.renderItems()}</Content>
      </Root>
    );
  }
}

Filter.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  toggleFilter: PropTypes.func,
  toggleCategory: PropTypes.func.isRequired
};

export default Filter;
